import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { Editor } from "react-draft-wysiwyg";
import {
  ContentState,
  EditorState,
  convertFromHTML,
  convertToRaw,
} from "draft-js";
import { toast } from "react-toastify";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import axiosInterceptorInstance from "../../../utils/axios.interceptor";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import DeleteIcon from "@mui/icons-material/Delete";
import "ag-grid-community/styles/ag-grid.css";
import draftToHtml from "draftjs-to-html";
import axios from "axios";
import sendCreditAxios from "../../../utils/sendCreditAxiosService";

const CheckBalance = () => {
  const [rowData, setRowData] = useState<any>([]);
  const [product, setProduct] = useState<any>("0");
  const [section, setSection] = useState<Number>(0);
  const [title, setTitle] = useState<string>("");
  const [shortCode, setShortCode] = useState<string>("");
  const [question, setQuestion] = useState<string>("");
  const [display_description, setDisplayDescription] = useState<string>("");
  const [display_H1, setDisplayH1] = useState<string>("");
  const [display_Para, setDisplayPara] = useState<string>("");
  const [display_Web, setDisplayWeb] = useState<string>("");
  const [display_Support, setDisplaySupport] = useState<string>("");
  const [editorState, setEditorState] = useState<EditorState>();
  const [editorFaqState, setEditorFaqState] = useState<EditorState>();
  const [h1EditorState, setH1EditorState] = useState<EditorState>();
  const [paraEditorState, setParaEditorState] = useState<EditorState>();
  const [webEditorState, setWebEditorState] = useState<EditorState>();
  const [supportEditorState, setSupportEditorState] = useState<EditorState>();
  const [submitRequest, setSubmitRequest] = useState<boolean>(false);
  const [country, setCountry] = useState<any>("0");
  const [operator, setOperator] = useState<any>("0");
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [Open, setOpen] = useState<boolean>(false);
  const [circular, setCircular] = useState<boolean>(true);
  const [countryListN, setCountryListN] = useState<any[]>([]);
  const [preview, setPreview] = useState<boolean>(false);
  const [faqs, setFaqs] = useState<any>([]);
  const [edit_faqs, setEditFaqs] = useState<any>([]);
  const [delete_faq, setDeleteFaq] = useState<any>([]);
  const [display_faq, setDisplayFaq] = useState<string>("");
  const [isCheck, setIsCheck] = useState<boolean>(false);
  const [deleteCheck, setDeleteCheck] = useState<boolean>(false);
  const [action, setAction] = useState<boolean>(false);
  const [redeem, setRedeem] = useState<boolean>(false);
  const [circle, setCircle] = useState<boolean>(false);

  const [crmCheckbalanceId, setCrmCheckbalanceId] = useState<any>(null);
  const [pageTitle, setPageTitle] = useState<any>({});
  const [pageDescription, setPageDescription] = useState<any>({});
  const [aboutSection, setAboutSection] = useState<any>({});
  const [webContent, setWebContent] = useState<any>({});
  const [supportContent, setSupportContent] = useState<any>({});

  const loadCountries = async () => {
    await fetch("/data/country.json")
      .then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error " + response.status);
        }
        return response.json();
      })
      .then((json: any) => {
        setCountryListN(json.countries);
      });
  };

  const controller = new AbortController();

  useEffect(() => {
    loadCountries();
    return () => {
      controller.abort();
    };
  }, []);

  useEffect(() => {
    if (country == "0" || country == undefined || operator == "0") {
      setIsOpen(false);
      setOpen(false);
      setCircular(false);
      setCircle(false);
    } else {
      setRowData([]);
      getOperator();
      setSection(0);
      setIsOpen(true);
      setCircular(true);
      setProduct(0);
      setFaqs([]);
    }
  }, [country, operator]);

  useEffect(() => {
    if (product != "0" && product != undefined && section == 1) {
      getDescription(product);
    }
  }, [product, section]);
  useEffect(() => {
    setCircle(false);
    if (product != "0" && product != undefined && section == 2) {
      getFAQ();
    }
  }, [product, section]);

  useEffect(() => {
    updateEditorAndDisplayFaq();
  }, [edit_faqs]);

  useEffect(() => {
    if (product == "0" || product == undefined) {
      setOpen(false);
    } else {
      setOpen(true);
      setShortCode(product.shortCode || "");
      setTitle(product.operatorName || "");
      ClearFaq();
    }
  }, [product]);

  useEffect(() => {
    const updateEditorAndDisplayDescription = () => {
      if (crmCheckbalanceId) {
        const blocksFromAbout = convertFromHTML(
          aboutSection?.aboutSection || "",
        );

        const contentStateAbout = ContentState.createFromBlockArray(
          blocksFromAbout.contentBlocks,
          blocksFromAbout.entityMap,
        );

        const newEditorStateAbout =
          EditorState.createWithContent(contentStateAbout);
        updateDescription(newEditorStateAbout);

        const blocksFromTitle = convertFromHTML(pageTitle?.pageTitle || "");
        const contentStateTitle = ContentState.createFromBlockArray(
          blocksFromTitle.contentBlocks,
          blocksFromTitle.entityMap,
        );

        const newEditorStateTitle =
          EditorState.createWithContent(contentStateTitle);
        updateH1(newEditorStateTitle);

        const blocksFromDescription = convertFromHTML(
          pageDescription?.pageDescription || "",
        );

        const contentStateDescription = ContentState.createFromBlockArray(
          blocksFromDescription.contentBlocks,
          blocksFromDescription.entityMap,
        );

        const newEditorStateDescription = EditorState.createWithContent(
          contentStateDescription,
        );

        updatePara(newEditorStateDescription);

        const blocksFromWeb = convertFromHTML(webContent?.webContent || "");

        const contentStateWeb = ContentState.createFromBlockArray(
          blocksFromWeb.contentBlocks,
          blocksFromWeb.entityMap,
        );

        const newEditorStateWeb =
          EditorState.createWithContent(contentStateWeb);
        updateWeb(newEditorStateWeb);

        const blocksFromSupport = convertFromHTML(
          supportContent?.supportContent || "",
        );

        const contentStateSupport = ContentState.createFromBlockArray(
          blocksFromSupport.contentBlocks,
          blocksFromSupport.entityMap,
        );

        const newEditorStateSupport =
          EditorState.createWithContent(contentStateSupport);
        updateSupport(newEditorStateSupport);
      } else {
        setEditorState(EditorState.createEmpty());
        setDisplayDescription("");

        setDisplayH1("");
        setH1EditorState(EditorState.createEmpty());

        setDisplayPara("");
        setParaEditorState(EditorState.createEmpty());

        setDisplayWeb("");
        setWebEditorState(EditorState.createEmpty());

        setDisplaySupport("");
        setSupportEditorState(EditorState.createEmpty());
      }
    };

    updateEditorAndDisplayDescription();
  }, [crmCheckbalanceId]);

  const updateEditorAndDisplayFaq = () => {
    if (edit_faqs && edit_faqs.answer) {
      setQuestion(edit_faqs.question);
      setRedeem(edit_faqs.isRedeem);
      const blocksFromHTML = convertFromHTML(edit_faqs.answer);
      const contentState = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap,
      );
      const newEditorState = EditorState.createWithContent(contentState);
      updateEditorAndDisplay(newEditorState);
    } else {
      setEditorFaqState(EditorState.createEmpty());
      setDisplayFaq("");
      setQuestion("");
      setRedeem(false);
    }
  };

  const updateEditorAndDisplay = (newEditorState: EditorState) => {
    setEditorFaqState(newEditorState);
    const value = draftToHtml(convertToRaw(newEditorState.getCurrentContent()));
    setDisplayFaq(value);
  };

  const onEditorFaqChange = (newEditorState: EditorState) => {
    updateEditorAndDisplay(newEditorState);
  };

  const updateDescription = (newEditorState: EditorState) => {
    setEditorState(newEditorState);
    const contentState = newEditorState.getCurrentContent();
    const isEmpty =
      !contentState.hasText() || contentState.getPlainText().trim() === "";

    const value = isEmpty ? "" : draftToHtml(convertToRaw(contentState));
    setDisplayDescription(value);
  };

  const onEditorStateChange = (newEditorState: EditorState) => {
    updateDescription(newEditorState);
  };

  const updateH1 = (newEditorState: EditorState) => {
    setH1EditorState(newEditorState);

    const contentState = newEditorState.getCurrentContent();
    const isEmpty =
      !contentState.hasText() || contentState.getPlainText().trim() === "";

    const value = isEmpty ? "" : draftToHtml(convertToRaw(contentState));
    setDisplayH1(value);
  };

  const onH1EditorStateChange = (newEditorState: EditorState) => {
    updateH1(newEditorState);
  };

  const updatePara = (newEditorState: EditorState) => {
    setParaEditorState(newEditorState);
    const contentState = newEditorState.getCurrentContent();
    const isEmpty =
      !contentState.hasText() || contentState.getPlainText().trim() === "";

    const value = isEmpty ? "" : draftToHtml(convertToRaw(contentState));
    setDisplayPara(value);
  };

  const onParaEditorStateChange = (newEditorState: EditorState) => {
    updatePara(newEditorState);
  };

  const updateWeb = (newEditorState: EditorState) => {
    setWebEditorState(newEditorState);
    const contentState = newEditorState.getCurrentContent();
    const isEmpty =
      !contentState.hasText() || contentState.getPlainText().trim() === "";

    const value = isEmpty ? "" : draftToHtml(convertToRaw(contentState));
    setDisplayWeb(value);
  };

  const onWebEditorStateChange = (newEditorState: EditorState) => {
    updateWeb(newEditorState);
  };

  const updateSupport = (newEditorState: EditorState) => {
    setSupportEditorState(newEditorState);
    const contentState = newEditorState.getCurrentContent();
    const isEmpty =
      !contentState.hasText() || contentState.getPlainText().trim() === "";

    const value = isEmpty ? "" : draftToHtml(convertToRaw(contentState));
    setDisplaySupport(value);
  };

  const onSupportEditorStateChange = (newEditorState: EditorState) => {
    updateSupport(newEditorState);
  };

  const getOperator = async () => {
    toast.dismiss();
    await sendCreditAxios
      .post(
        `/Operator/ByCategory`,
        {
          page: 1,
          recordsPerPage: 999,
          operatorFilters: {
            countryIsoCode: country.isoCode2,
            currencyCode: "USD",
            categoryAliasName: operator,
          },
        },
        { signal: controller.signal },
      )
      .then((response: any) => {
        const responseData = response?.data.payload.data;
        let finalData: any[] = [];
        responseData.forEach((item: any) => {
          finalData.push(item.operator);
        });
        if (finalData.length == 0) {
          toast.error("No Record Found");
          setCircular(false);
        } else {
          setRowData(finalData);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const handleSave = async () => {
    if (title !== "" && shortCode !== "" && product !== "0" && section == 1) {
      AddDescription();
    } else if (
      title !== "" &&
      shortCode !== "" &&
      product !== "0" &&
      section == 2
    ) {
      CheckFaqAndDescription();
    } else {
      toast.error("Please enter the required inputs.");
    }
  };

  const AddDescription = async () => {
    setSubmitRequest(true);

    await sendCreditAxios
      .post(`/CMSOperator/AddBalance`, {
        ...(crmCheckbalanceId ? { crmCheckBalanceId: crmCheckbalanceId } : {}),
        country: country.isoCode2,
        operatorName: product.operatorName,
        operatorShortCode: product.shortCode,
        productType: operator,
        contentType: "Content",
        fieldDetails: [
          {
            fieldKey: "pageTitle",
            fieldValue: display_H1,
            ...(pageTitle.CRMCheckbalanceMetaId
              ? { crmCheckBalancMetaId: pageTitle.CRMCheckbalanceMetaId }
              : {}),
          },
          {
            fieldKey: "pageDescription",
            fieldValue: display_Para,
            ...(pageDescription.CRMCheckbalanceMetaId
              ? { crmCheckBalancMetaId: pageDescription.CRMCheckbalanceMetaId }
              : {}),
          },
          {
            fieldKey: "aboutSection",
            fieldValue: display_description,
            ...(aboutSection.CRMCheckbalanceMetaId
              ? { crmCheckBalancMetaId: aboutSection.CRMCheckbalanceMetaId }
              : {}),
          },
          {
            fieldKey: "webContent",
            fieldValue: display_Web,
            ...(webContent.CRMCheckbalanceMetaId
              ? { crmCheckBalancMetaId: webContent.CRMCheckbalanceMetaId }
              : {}),
          },
          {
            fieldKey: "supportContent",
            fieldValue: display_Support,
            ...(supportContent.CRMCheckbalanceMetaId
              ? { crmCheckBalancMetaId: supportContent.CRMCheckbalanceMetaId }
              : {}),
          },
        ],
      })
      .then((res: any) => {
        const data = res.data;
        toast.success(data.message);
      })
      .catch((error: any) => {
        setSubmitRequest(false);
      })
      .finally(() => {
        setSubmitRequest(false);
        getDescription(product);
      });
  };

  const getDescription = async (product: any) => {
    setCrmCheckbalanceId(null);
    setPageTitle({});
    setPageDescription({});
    setAboutSection({});
    setWebContent({});
    setSupportContent({});
    try {
      const dataToSend = {
        countryIsoCode: country.isoCode2,
        operatorShortCode: product.shortCode,
        productType: operator,
        contentType: "Content",
      };

      const response = await sendCreditAxios.post(
        "/CMSOperator/GetBalance",
        dataToSend,
      );

      const { payload } = response?.data || {};

      if (payload) {
        setCrmCheckbalanceId(payload?.crmCheckbalanceId);

        payload.data.forEach((item: any) => {
          if (item.pageTitle || item.pageTitle == "") {
            setPageTitle(item);
          } else if (item.pageDescription || item.pageDescription == "") {
            setPageDescription(item);
          } else if (item.aboutSection || item.aboutSection == "") {
            setAboutSection(item);
          } else if (item.webContent || item.webContent == "") {
            setWebContent(item);
          } else if (item.supportContent || item.supportContent == "") {
            setSupportContent(item);
          }
        });
      } else {
        // setContent(null);
        toast.info(response.data.message);
        setCrmCheckbalanceId(null);
        setPageTitle({});
        setPageDescription({});
        setAboutSection({});
        setWebContent({});
        setSupportContent({});
      }
    } catch (error) {
      console.error({ error });
      // setContent(null);
    }
  };

  const getFAQ = async () => {
    setCircle(true);
    await sendCreditAxios
      .post(`/CMSOperator/GetFAQ`, {
        countryIsoCode: country.isoCode2,
        operatorShortCode: product.shortCode,
        productType: operator,
      })
      .then((response) => {
        setCircle(false);
        const responseData = response?.data.payload;
        if (responseData) {
          setFaqs(responseData);
        } else {
          setFaqs([]);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const AddFaq = async () => {
    setSubmitRequest(true);
    await sendCreditAxios
      .post(`/CMSOperator/AddFAQ`, {
        country: country.isoCode2,
        operatorName: product.operatorName,
        operatorShortCode: product.shortCode,
        productType: operator,
        crmOperatorFaqId: faqs.crmOperatorFaqId,
        details: [
          {
            ...(edit_faqs?.operatorFaqMetaId
              ? { operatorFaqMetaId: edit_faqs.operatorFaqMetaId }
              : {}),
            question: question,
            answer: display_faq,
            isRedeem: redeem,
          },
        ],
      })
      .then((res: any) => {
        const data = res.data;
        toast.success(data.message);
        getFAQ();
        ClearFaq();
      })
      .catch((error: any) => {
        setSubmitRequest(false);
      })
      .finally(() => {
        setSubmitRequest(false);
      });
  };

  const deleteFAQ = async () => {
    setAction(true);
    await sendCreditAxios
      .post(`/CMSOperator/DeleteFAQDetail`, {
        faqMetaId: delete_faq.operatorFaqMetaId,
      })
      .then((res: any) => {
        const data = res.data;
        setDeleteCheck(false);
        setAction(false);
        getFAQ();
        toast.success(data.message);
      })
      .catch((error: any) => {
        setAction(false);
        setDeleteCheck(false);
      });
  };
  const ClearFaq = () => {
    setIsCheck(false);
    setQuestion("");
    setRedeem(false);
    setEditorFaqState(EditorState.createEmpty());
    setDisplayFaq("");
    setEditFaqs([]);
  };
  const CheckFaqAndDescription = () => {
    // if (isCheck && display_faq != "" && question != "") {
    //   UpdateFaq();
    // } else
    if (display_faq != "" && question != "") {
      AddFaq();
    } else {
      toast.error("Please enter the required inputs.");
    }
  };

  console.log(display_H1);
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ ease: "linear", duration: 0.5 }}
    >
      <div className="boxShadow">
        <h2 className="sectionTitle">Check Balance</h2>
        <div className="boxInner">
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <fieldset>
                <legend>General Information:</legend>
                <Grid container spacing={2}>
                  <Grid item xs={6}>
                    {countryListN && (
                      <FormControl style={{ width: "100%" }}>
                        <InputLabel
                          id="demo-simple-select-label"
                          style={{ background: "#fff", padding: " 0 5px" }}
                        >
                          Countries
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          className="formControl"
                          autoWidth
                          value={country?.isoCode2 || "0"}
                          defaultValue={country?.isoCode2 || "0"}
                          onChange={(e: any) => {
                            const country = countryListN?.find(
                              (item) => item.isoCode2 === e.target.value,
                            );
                            setCountry(country);
                          }}
                        >
                          <MenuItem value="0">Select Country</MenuItem>
                          {countryListN.map((item, index) => (
                            <MenuItem key={index} value={item?.isoCode2}>
                              {item?.countryName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  </Grid>

                  <Grid item xs={6}>
                    <FormControl style={{ width: "100%" }}>
                      <InputLabel
                        id="demo-simple-select-label"
                        style={{ background: "#fff", padding: " 0 5px" }}
                      >
                        Operator Type
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        className="formControl"
                        autoWidth
                        value={operator}
                        defaultValue={operator}
                        onChange={(e: any) => {
                          setOperator(e.target.value);
                        }}
                      >
                        <MenuItem value="0">Choose Type</MenuItem>
                        <MenuItem value="gift_cards"> Gift Card </MenuItem>
                        <MenuItem value="mobile">Mobile</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </fieldset>
            </Grid>
            {circular == true && rowData.length == 0 && (
              <div className="circular-loader">
                <CircularProgress size={40} />
              </div>
            )}
            {isOpen && rowData.length > 0 && (
              <Grid item xs={12}>
                <fieldset>
                  <legend>Product Selection:</legend>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <FormControl style={{ width: "100%" }}>
                        <InputLabel
                          id="demo-simple-select-label"
                          style={{ background: "#fff", padding: " 0 5px" }}
                        >
                          Product
                        </InputLabel>

                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          className="formControl"
                          autoWidth
                          value={product?.operatorId || "0"}
                          defaultValue={product?.operatorId || "0"}
                          onChange={(e: any) => {
                            const product = rowData?.find(
                              (item: any) => item.operatorId === e.target.value,
                            );

                            setProduct(product);
                          }}
                        >
                          <MenuItem value="0">Choose Product</MenuItem>

                          {rowData?.map((item: any, index: any) => (
                            <MenuItem key={index} value={item?.operatorId}>
                              {item?.operatorName}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={6}>
                      <FormControl style={{ width: "100%" }}>
                        <InputLabel
                          id="demo-simple-select-label"
                          style={{ background: "#fff", padding: " 0 5px" }}
                        >
                          Section
                        </InputLabel>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          className="formControl"
                          autoWidth
                          value={section}
                          defaultValue={section}
                          onChange={(e: any) => {
                            setSection(e.target.value);
                          }}
                        >
                          <MenuItem value="0">Choose Type</MenuItem>
                          <MenuItem value="1"> Content</MenuItem>
                          <MenuItem value="2">FAQ</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </Grid>
                </fieldset>
              </Grid>
            )}
            {Open && section != 0 && (
              <Grid item xs={12}>
                <fieldset>
                  <legend>Operator Information:</legend>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <TextField
                        className="formControl"
                        label="Title"
                        variant="outlined"
                        value={title}
                        inputProps={{ maxLength: 200 }}
                        onChange={(e: any) => {
                          setTitle(e.target.value);
                        }}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        className="formControl"
                        label="Short Code"
                        variant="outlined"
                        value={shortCode}
                        inputProps={{ maxLength: 200, readOnly: true }}
                        onChange={(e: any) => {
                          setShortCode(e.target.value);
                        }}
                      />
                    </Grid>
                  </Grid>
                </fieldset>
              </Grid>
            )}

            {section == 1 &&
              country != undefined &&
              country != "0" &&
              operator !== "0" &&
              product != "0" &&
              product != undefined && (
                <Grid item xs={12}>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <div className="boxShadow editor balance">
                        <h2 style={{ margin: "5px 10px" }}>H1 Editor</h2>
                        <Editor
                          editorState={h1EditorState}
                          toolbarClassName="toolbarClassName"
                          wrapperClassName="wrapperClassName"
                          editorClassName="editorScrollable"
                          onEditorStateChange={onH1EditorStateChange}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={6}>
                      <div className="boxShadow editor balance">
                        <h2 style={{ margin: "5px 10px" }}>Paragraph Editor</h2>
                        <Editor
                          editorState={paraEditorState}
                          toolbarClassName="toolbarClassName"
                          wrapperClassName="wrapperClassName"
                          editorClassName="editorScrollable"
                          onEditorStateChange={onParaEditorStateChange}
                        />
                      </div>
                    </Grid>
                  </Grid>

                  <div className="boxShadow editor">
                    <h2 style={{ margin: "5px 10px" }}>About Editor</h2>
                    <Editor
                      editorState={editorState}
                      toolbarClassName="toolbarClassName"
                      wrapperClassName="wrapperClassName"
                      editorClassName="editorScrollable"
                      onEditorStateChange={onEditorStateChange}
                    />
                  </div>

                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <div className="boxShadow editor balance">
                        <h2 style={{ margin: "5px 10px" }}>Web Editor</h2>
                        <Editor
                          editorState={webEditorState}
                          toolbarClassName="toolbarClassName"
                          wrapperClassName="wrapperClassName"
                          editorClassName="editorScrollable"
                          onEditorStateChange={onWebEditorStateChange}
                        />
                      </div>
                    </Grid>
                    <Grid item xs={6}>
                      <div className="boxShadow editor balance">
                        <h2 style={{ margin: "5px 10px" }}>Support Editor</h2>
                        <Editor
                          editorState={supportEditorState}
                          toolbarClassName="toolbarClassName"
                          wrapperClassName="wrapperClassName"
                          editorClassName="editorScrollable"
                          onEditorStateChange={onSupportEditorStateChange}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              )}

            {section == 2 &&
              faqs.length !== 0 &&
              country !== undefined &&
              country !== "0" &&
              operator !== "0" &&
              product !== "0" &&
              product !== undefined &&
              !circle && (
                <div className="faq-list-container">
                  <h2>Frequently Asked Questions</h2>
                  <Grid item xs={12}>
                    {faqs.detail.map((faq: any, index: number) => (
                      <div key={faq.id} className="faq-item">
                        <div className="faq-header">
                          <h3 style={{ padding: "0" }}>
                            Q{faq.operatorFaqMetaId}:{faq.question}
                          </h3>
                          <div className="faq-header">
                            {faq.isRedeem ? (
                              <p className="Redeem">Redeem</p>
                            ) : null}
                            <DriveFileRenameOutlineOutlinedIcon
                              className="edit-button"
                              style={{ marginRight: "20px" }}
                              onClick={() => {
                                (setEditFaqs(faq), setIsCheck(true));
                              }}
                            ></DriveFileRenameOutlineOutlinedIcon>
                            <DeleteIcon
                              className="edit-button"
                              onClick={() => {
                                (setDeleteFaq(faq), setDeleteCheck(true));
                              }}
                            ></DeleteIcon>
                          </div>
                        </div>
                        <p dangerouslySetInnerHTML={{ __html: faq.answer }} />
                        <hr />
                      </div>
                    ))}
                  </Grid>
                </div>
              )}
            {circle && (
              <div className="circular-loader">
                <CircularProgress size={40} />
              </div>
            )}
            {section == 2 &&
              country != undefined &&
              country != "0" &&
              product != "0" &&
              product != undefined && (
                <Grid item xs={12}>
                  <h2
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    FAQ Section{" "}
                    <Button
                      className="dButton "
                      variant="contained"
                      style={{ width: "10%", height: "35px" }}
                      onClick={() => ClearFaq()}
                    >
                      Clear
                    </Button>
                  </h2>

                  <Grid item xs={12}>
                    <TextField
                      className="formControl"
                      label="Question"
                      variant="outlined"
                      value={question}
                      inputProps={{ maxLength: 200 }}
                      onChange={(e: any) => {
                        setQuestion(e.target.value);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <FormControlLabel
                      style={{ marginLeft: "0px" }}
                      control={
                        <Checkbox
                          checked={redeem}
                          onChange={(e: any) => setRedeem(e.target.checked)}
                          inputProps={{ "aria-label": "controlled" }}
                          size="medium"
                        />
                      }
                      label="Redeem"
                      labelPlacement="start"
                    />
                  </Grid>
                  <h2>Answer</h2>
                  <div className="boxShadow editor">
                    <Editor
                      editorState={editorFaqState}
                      toolbarClassName="toolbarClassName"
                      wrapperClassName="wrapperClassName"
                      editorClassName="editorScrollable"
                      onEditorStateChange={onEditorFaqChange}
                    />
                  </div>
                </Grid>
              )}
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={3} style={{ marginLeft: "30%" }}>
                  {!submitRequest && Open && section != 0 && (
                    <Button
                      className="dButton "
                      variant="contained"
                      onClick={() => handleSave()}
                    >
                      Save
                    </Button>
                  )}
                  {submitRequest && (
                    <Button className="dButton " variant="contained">
                      <CircularProgress color="inherit" size={30} />
                    </Button>
                  )}
                </Grid>
                <Grid item xs={3}>
                  {(display_description ||
                    display_H1 ||
                    display_Para ||
                    display_Support ||
                    display_Web) &&
                    country != undefined &&
                    country != "0" &&
                    product != "0" &&
                    product != undefined &&
                    section == 1 && (
                      <Button
                        className="dButton "
                        variant="contained"
                        onClick={() => setPreview(true)}
                      >
                        Preview
                      </Button>
                    )}
                </Grid>
              </Grid>
            </Grid>

            <Dialog
              className="operator-preview"
              open={preview}
              onClose={() => setPreview(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <div dangerouslySetInnerHTML={{ __html: display_H1 }} />
              <div dangerouslySetInnerHTML={{ __html: display_description }} />
              <div dangerouslySetInnerHTML={{ __html: display_Para }} />
              <div dangerouslySetInnerHTML={{ __html: display_Web }} />
              <div dangerouslySetInnerHTML={{ __html: display_Support }} />
            </Dialog>

            <Dialog
              open={deleteCheck}
              onClose={() => setDeleteCheck(false)}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"Delete FAQ Confirmation"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  Would you really like to delete this FAQ?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  variant="contained"
                  className="dButton dButton2 dbuttonSec"
                  onClick={() => setDeleteCheck(false)}
                >
                  No
                </Button>
                <div style={{ width: "30px" }}></div>
                {!action && (
                  <Button
                    variant="contained"
                    className="dButton dButton2"
                    onClick={() => {
                      deleteFAQ();
                    }}
                    autoFocus
                  >
                    Yes
                  </Button>
                )}
                {action && (
                  <Button className="dButton dButton2" variant="contained">
                    <CircularProgress color="inherit" size={30} />
                  </Button>
                )}
              </DialogActions>
            </Dialog>
          </Grid>
        </div>
      </div>
    </motion.div>
  );
};

export default CheckBalance;
